import React from 'react'

const Credits = () => {
  return (
    <div className='card'>
        <div className='card-body text-center '>
            <h3 className='mb-2 text-blue-900'>Credits</h3>
            <h6 className='text-gray mb-9'>Select an amount of credits to add</h6>
            <h5 className='text-decoration-underline text-blue-900 mb-6'>Current balance of credits - 860</h5>
            <div className='content-990 mx-auto'>
                <div className='row mb-9 '>
                    <div className='col-12 col-md-6 col-lg'>
                        <div className='card d-flex flex-column align-items-center  px-3 py-9 pt-cursor mb-4 mb-lg-0'>
                            <div className="icon-wrap icon-lg icon-blue bg-white mb-4">
                                <i className='icon-cent fs-2' />
                            </div>
                            <h3 className='mb-0 text-blue-900'>1000</h3>
                            <span className='text-small'>credits</span>
                            <h5 className='mt-6 text-blue-600'>$2,50</h5>
                        </div>
                    </div>
                    <div className='col-12 col-md-6 col-lg'>
                        <div className='card  d-flex flex-column align-items-center border-blue-400 px-3 py-9 pt-cursor mb-4 mb-lg-0 '>
                            <div className="icon-wrap icon-lg icon-blue bg-white mb-4">
                                <i className='icon-cent fs-2' />
                            </div>
                            <h3 className='mb-0 text-blue-900'>2000</h3>
                            <span className='text-small'>credits</span>
                            <h5 className='mt-6 text-blue-600'>$5,00</h5>
                        </div>
                    </div>
                    <div className='col-12 col-md-6 col-lg'>
                        <div className='card d-flex flex-column align-items-center  px-3 py-9 pt-cursor mb-4 mb-lg-'>
                            <div className="icon-wrap icon-lg icon-blue bg-white mb-4">
                                <i className='icon-cent fs-2' />
                            </div>
                            <h3 className='mb-0 text-blue-900'>5000</h3>
                            <span className='text-small'>credits</span>
                            <h5 className='mt-6 text-blue-600'>$12,50</h5>
                        </div>
                    </div>
                    <div className='col-12 col-md-6 col-lg'>
                        <div className='card d-flex flex-column align-items-center  px-3 py-9 pt-cursor mb-4 mb-lg-'>
                            <div className="icon-wrap icon-lg icon-blue bg-white mb-4">
                                <i className='icon-cent fs-2' />
                            </div>
                            <h3 className='mb-0 text-blue-900'>10000</h3>
                            <span className='text-small'>credits</span>
                            <h5 className='mt-6 text-blue-600'>$25,00</h5>
                        </div>
                    </div>
                    <div className='col-12 col-md-6 col-lg'>
                        <div className='card d-flex flex-column align-items-center  px-3 py-9 pt-cursor mb-4 mb-lg-'>
                            <div className="icon-wrap icon-lg icon-blue bg-white mb-4">
                                <i className='icon-cent fs-2' />
                            </div>
                            <h3 className='mb-0 text-blue-900'>Custom</h3>
                            <span className='text-small'>credits</span>
                            <h5 className='mt-6 text-blue-600'>1 - $0,0025 </h5>
                        </div>
                    </div>
                </div>
            </div>
            <button className='btn btn-outline-primary content-300 w-100 me-3 mb-4 mb-md-0'><span className='btn-upper-case'>Cancel</span></button>
            <button className='btn btn-primary content-300 w-100'><span className='btn-upper-case'>Buy</span></button>
        </div>
    </div>
  )
}

export default Credits